(($)=>{

    "use strict"; 

	$('.control-feature').click(function(){
		var id = $(this).attr('id').replace('feature', '');
		var tools_class = 'tools'+id;
		var txt = $(this).find('.control-feature-title').text();
		if($("."+tools_class).length) {

			$(".control_tools").removeClass('active');
			$(".what_to_control > .row").addClass('step2');
			$("."+tools_class).addClass('active');
			$(".nav-what_to_control").addClass('hidden');
			$(".nav-control_tools").removeClass('hidden');
			$("#back-to-features").removeClass('hidden');
			$("#current_step").text('2');
			$("#control-title").html('Select a console to learn how to <span>'+txt+'</span>:');

			// Activate only one slider a time.
			$("."+tools_class+" > .row").slick({
				slidesToShow: 4,
				slidesToScroll: 1,
				infinite: false,
				prevArrow: $('.section-control_tools .nav.nav-control_tools .prev'),
				nextArrow: $('.section-control_tools .nav.nav-control_tools .next'),
				responsive: [
					/*{
						breakpoint: 1860,
						settings: {
							slidesToShow: 4
						}
					},*/
					{
						breakpoint: 1200,
						settings: {
							slidesToShow: 3
						}
					},
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 2
						}
					},
					{
						breakpoint: 576,
						settings: {
							slidesToShow: 1
						}
					}
				]
			});
		}
	});

	$('#back-to-features').click(function(e){
		e.stopPropagation();
		if(!$(this).hasClass('hidden')) {
			$(this).addClass('hidden');
			$(".what_to_control > .row").removeClass('step2');
			var $activeSlider = $(".control_tools.active > .row");
			$(".control_tools").removeClass('active');
			$(".nav-what_to_control").removeClass('hidden');
			$(".nav-control_tools").addClass('hidden');
			$("#current_step").text('1');
			$("#control-title").text('What would you like to control?');

			// Deactivate active slider.
			setTimeout( function() {
				$activeSlider.slick('unslick');
			}, 600 );
		}
	});

	$('.control-feature a').click(function(e){
		e.stopPropagation();
	});

	$('.what_to_control > .row').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		infinite: false,
		prevArrow: $('.section-control_tools .nav.nav-what_to_control .prev'),
		nextArrow: $('.section-control_tools .nav.nav-what_to_control .next'),
		responsive: [
			/*{
				breakpoint: 1860,
				settings: {
					slidesToShow: 4
				}
 			},*/
 			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3
				}
 			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 576,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 320,
				settings: {
					slidesToShow: 1
				}
			}
		]
	})

})(jQuery);